var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 290.262 290.262",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34_3-4k_Full_HD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.743,29.29H11.519C5.157,29.29,0,34.447,0,40.809v128.645v11.355v68.645c0,6.361,5.157,11.519,11.519,11.519h267.225 c6.361,0,11.519-5.157,11.519-11.519v-68.645v-11.355V40.809C290.262,34.447,285.104,29.29,278.743,29.29z M56.563,185.959H33.751 v15.375H54.19v4.813H33.751v18.748h-4.996v-43.748h27.809V185.959z M99.69,206.895c0,11.375-6.875,18.252-18.313,18.252 c-11.5,0-18.436-6.877-18.436-18.252v-25.748h5v25.748c0,8.5,5.122,13.439,13.436,13.439c8.313,0,13.313-4.939,13.313-13.439 v-25.748h5V206.895z M136.13,224.895h-24.188v-43.748h5v39.002h19.188V224.895z M168.444,224.895h-24.188v-43.748h4.998v39.002 h19.189V224.895z M214.693,224.895h-11.126v-16.998h-18.121v16.998h-11.127v-43.748h11.127v18h18.121v-18h11.126V224.895z  M241.822,224.895h-18.376v-25.201h11.125v16.33h7.938c6.812,0,11.688-5.254,11.688-12.939c0-7.754-5.126-13.063-12.188-13.063 h-18.563v-8.875h18.813c13.75,0,23.248,8.875,23.248,21.873C265.507,215.957,255.882,224.895,241.822,224.895z M267.225,157.935 H23.037V52.327h244.188V157.935z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.752,143.336 125.882,143.336 125.882,125.48 136.895,125.48 136.895,109.83 125.882,109.83 125.882,92.439  106.752,92.439 106.752,109.83 89.594,109.83 113.708,62.18 93.883,62.18 68.261,111.686 68.261,125.48 106.752,125.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.275,123.395 178.057,111.453 199.505,143.336 224.199,143.336 192.085,95.801 222.229,62.18 198.346,62.18  167.275,97.309 167.275,62.18 146.638,62.18 146.638,143.336 167.275,143.336  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4K);
export default __webpack_public_path__ + "static/media/4k.4962e0cc880cbc5a494d5d9f6bc37d5d.svg";
export { ForwardRef as ReactComponent };